import * as React from 'react';
import * as moment from 'moment';
import AmCharts from "@amcharts/amcharts3-react";
import { _ } from "@src/services/i18n";
import { classNames, css, mixin, vars, defaultProps } from '@src/services/theme';
import { Proto, Props, State } from '@src/components/Proto';
import { Ratio, Box, Gauge } from '@src/components';

// typing
interface LocalProps extends Props {
    filters?: any;
}

// style
const style = css`
    display: flex;

    > * {
        width: ${100/3}%;
    }
    > article {
        padding: 20px 0;
        text-align: center;
        > .iconBadge {
            ${mixin.iconBadge}
        }
        > h4 {
            font-size: 24px;
        }
        > h5 {
            font-size: 20px;
            color: ${vars.colors.blue};
            margin: 0;
            padding: 10px 0;
        }
    }
`;

// component
export class AverageData extends Proto<LocalProps, State> {
    
    componentWillReceiveProps(props) {
        this.loadWhenFiltersChanged( props, this.props );
    }
    
	// render
	render() {
        const loading = this.loading();
        if (loading) return loading;
        const { data } = this.state;
      
		return (
            <Box title={_('averagedata_title', 'Fleet')} collapsed={false}>
                <div className={style}>
                    <article>
                        <Gauge value={parseFloat(data.soh)} />
                        <h5>{data.soh}%</h5>
                        <h4>
                            {_('averagedata_soh', 'Fleet')}
                        </h4>
                    </article>
                    <article>
                        <span className="iconBadge">
                            <i className="fa fa-calendar" />
                            <strong><span>{data.days}</span></strong>
                        </span>
                        <h4>{_('averagedata_dof', 'Fleet')}</h4>
                    </article>
                    <article>
                        <span className="iconBadge">
                            <i className="fa fa-bolt" />
                            <strong>{data.cycles}</strong>
                        </span>
                        <h4>{_('averagedata_cycles', 'Fleet')}</h4>
                    </article>
                </div>
            </Box>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Fleet/AverageData.tsx